import { render, staticRenderFns } from "./VehiculoForm.vue?vue&type=template&id=36a6bc88"
import script from "./VehiculoForm.vue?vue&type=script&lang=js"
export * from "./VehiculoForm.vue?vue&type=script&lang=js"
import style0 from "./VehiculoForm.vue?vue&type=style&index=0&id=36a6bc88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports